module.exports = __webpack_public_path__ + "media/images/ic-index-sell-e421f01704e3cd7c6263a4c2a666df37.svg";